import React from "react";
import "./about.css";
import Header from "../../components/Header/Header";
import useTranslation from "../../hooks/useTranslation";
import { Ic_acercade } from "../../helpers/ImagesCache";
import colaboradorEnfermeriaMurcia from "../../images/aboutUs/enfermeriaMurcia.png";
import colaboradorSATSE from "../../images/aboutUs/satse.jpeg";

const About = () => {
  const T = useTranslation();

  return (
    <div className="min-h-screen flex flex-col w-full bg-white overflow-y-auto">
      <Header minimal={true} />
      <main className="flex-1 mx-auto px-10 py-6 flex flex-col gap-6 max-w-4xl">
        <div className="flex items-center gap-4">
          <img
            className="h-[40px] w-[40px] cursor-pointer"
            src={Ic_acercade}
            alt="About Icon"
          />
          <p className="text-gray-700 text-[16px] uppercase font-semibold">
            {T("about")}
          </p>
        </div>

        <h2 className="font-roboto font-bold text-[28px] text-[#333233]">
          {T("about_title")}
        </h2>

        <p className="text-gray-700 text-[16px] leading-relaxed">
          {T("about_description")}
        </p>

        <section>
          <h2 className="font-bold text-[20px] text-[#333233] mb-2">
            {T("applications_title")}
          </h2>
          <div className="space-y-3 text-gray-700 text-[16px]">
            {T("applications_description")
              .split("\n")
              .map((line, i) => {
                const [label, ...rest] = line.split(":");
                const content = rest.join(":").trim();
                return (
                  <p key={i}>
                    <span
                      className="font-semibold text-[#228C80]"
                    >
                      {label.trim()}:
                    </span>{" "}
                    {content}
                  </p>
                );
              })}
          </div>
        </section>

        <section>
          <h2 className="font-bold text-[20px] text-[#333233] mb-2">
            {T("audience_title")}
          </h2>
          <div className="space-y-2 text-gray-700 text-[16px]">
            {T("audience_description")
              .split("\n")
              .map((line, i) => (
                <p key={i}>• {line.replace(/^-\s*/, "")}</p>
              ))}
          </div>
        </section>

        <section>
          <h2 className="font-bold text-[20px] text-[#333233] mb-2">
            {T("authors_title")}
          </h2>
          <p className="text-gray-700 whitespace-pre-line text-[16px] leading-relaxed">
            {T("authors_description")}
          </p>
        </section>

        <section>
          <h2 className="font-bold text-[20px] text-[#333233] mb-4">
            {T("collaborators_title")}
          </h2>
          <div className="flex flex-col gap-6">
            {T("collaborators_description")
              .split("\n")
              .map((name, index) => {
                const images = [colaboradorEnfermeriaMurcia, colaboradorSATSE];
                const imageSizes = [
                  "h-[160px] w-[160px]", // Larger size for colaboradorEnfermeriaMurcia
                  "h-[80px] w-[80px]"    // Smaller size for colaboradorSATSE
                ];
                return (
                  <div key={index} className="flex items-center gap-4">
                    <p className="text-gray-700 text-[16px] text-left">
                      {name}
                    </p>
                    <img
                      src={images[index]}
                      alt={`Collaborator ${index + 1}`}
                      className={`${imageSizes[index]} object-contain`}
                    />
                  </div>
                );
              })}
          </div>
        </section>
      </main>
    </div>
  );
};

export default About;
